"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Youtube.scss");
var _Flex = _interopRequireDefault(require("./Flex"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Make sure to create this CSS file

function YoutubeVideo(_ref) {
  var videoId = _ref.videoId;
  var youtubeEmbedUrl = "https://www.youtube-nocookie.com/embed/".concat(videoId, "?modestbranding=1&rel=0&showinfo=0&autoplay=0&controls=1&disablekb=1&fs=1&noCookie=true");
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    customClass: "YoutubeVideo-Container"
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    customClass: "YoutubeVideo"
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    src: youtubeEmbedUrl,
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    title: "Embedded youtube"
  })));
}
var _default = exports["default"] = YoutubeVideo;